import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";

type Props = {
    onEditButtonClick: () => void
}

const TopButtonArea = ({
    onEditButtonClick
}: Props) => {
    return (
        <>
            <Grid item xs={6} style={{
                textAlign: 'left',
                paddingBottom: 0
            }}>
                <Typography display="inline" variant="h4" style={{ color: "white", marginLeft: "10px", top: "50%", position: "relative", textAlign: "left" }}>Attack</Typography>
            </Grid>
            <Grid item xs={6} style={{
                textAlign: 'right',
                justifyContent: 'right',
                alignContent: 'right',
                paddingBottom: 0
            }}>
                <Button variant="contained" color="primary" onClick={onEditButtonClick}>
                    編集
                </Button>
            </Grid>
        </>
    );
}

export default TopButtonArea;